import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

// import {
  
// } from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// A generic paginated getter
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetPaginated = packet => {
  return {
    type: 'REQUEST_GET_PAGINATED',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetPaginatedSuccess = data => ({
  type: 'RECEIVE_GET_PAGINATED_SUCCESS',
  data
})

export const receiveGetPaginatedFail = data => ({
  type: 'RECEIVE_GET_PAGINATED_FAIL',
  data
})

export const tryToGetPaginated = packet => (dispatch, getState) => {

  dispatch(requestGetPaginated(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  let params = {};
  if(packet.startAfter){
    params.startAfter = packet.startAfter;
  }
  if(packet.orderBy){
    params.orderBy = packet.orderBy;
  }

  return fetch('/api/shared/pagination/' + packet.kind + '/' + packet.id + '/' + packet.collection  + '?' + new URLSearchParams(params), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetPaginatedSuccess({
        request: packet,
        response: json
      }));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetPaginatedFail({errors:e, lastSubmit: packet}));
    })
}
